import React, { useRef, useState } from "react";
import { styled } from "@mui/material";
import { ClinicColors } from "fe-web-components/styles/clinicTheme";
import { scrollableStyle } from "fe-common/ui/commonStyles";

//region [[ Styles ]]
export const PageWrapperView = styled("div")({
  display: "flex",
  flexDirection: "column",
  height: "100%",
});

export const PageTitle = styled("div")({
  padding: "20px 40px 14px",
  fontWeight: "bold",
  fontSize: 20,
  display: "flex",
  alignItems: "center",
  zIndex: 200,
  backgroundColor: ClinicColors.mainBackground,
  gap: 12,
  "&.shadowed": {
    boxShadow: "0 3px 2px -2px rgba(0,0,0,.2)",
  },
});

export const PageContent = styled("div")({
  padding: "1px 40px 20px",
  ...scrollableStyle,
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PageComponentsProps {
  className?: string;
  style?: React.CSSProperties;
  pageTitle?: React.ReactNode;
  pageTitleStyle?: React.CSSProperties;
  children: React.ReactNode;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicPageWrapper = ({ ...props }: PageComponentsProps) => {
  const [shadowedHeader, setShadowedHeader] = useState(false);
  const contentRef = useRef(null);

  const handleScroll = (e) => {
    if (e.target === contentRef.current)
      setShadowedHeader(e.target?.scrollTop > 0);
  };

  return (
    <PageWrapperView className={props.className} style={props.style}>
      {props.pageTitle && (
        <PageTitle
          className={shadowedHeader ? "shadowed" : ""}
          style={props.pageTitleStyle}
        >
          {props.pageTitle}
        </PageTitle>
      )}
      <PageContent onScroll={handleScroll} ref={contentRef}>
        {props.children}
      </PageContent>
    </PageWrapperView>
  );
};
